import React from 'react'
import PropTypes from 'prop-types'

import './styles.scss'

const ContactPerson = ({
  contactPersonImg,
  fullName,
  title,
  email,
  phoneNumber,
}) => (
  <div className="contact-person">
    <figure className="contact-person__photo">
      <img
        className="contact-person__photo--size"
        src={contactPersonImg}
        alt={fullName}
      />
    </figure>

    <div className="contact-person__info">
      <p className="contact-person__info__name">{fullName}</p>
      <p className="contact-person__info__title">{title}</p>

      <div>
        <a className="contact-person__info__email" href={`mailto:${email}`}>
          {email}
        </a>
      </div>

      <div>
        <a className="contact-person__info__phone" href={`tel:${phoneNumber}`}>
          {phoneNumber}
        </a>
      </div>
    </div>
  </div>
)

ContactPerson.propTypes = {
  contactPersonImg: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  phoneNumber: PropTypes.string.isRequired,
}

export default ContactPerson
